import { carousel } from "../js/main";

export function pipeChainCardCarousel() {
  document.querySelectorAll(".pipechain-card-carousel-block").forEach((el) => {
    const glider = el.querySelector(".pipechain-card-carousel__glider");
    const slides = el.querySelectorAll(".pipechain-carousel__card");
    let prevSimSlides = 1;
    carousel(
      el,
      slides as NodeListOf<HTMLElement>,
      [1, 2, 3, 3],
      (_, simSlides) => {
        if (glider) {
          glider.classList.remove("grid-cols-" + prevSimSlides);
          glider.classList.add("grid-cols-" + simSlides);
          prevSimSlides = simSlides;
        }
      }
    );
  });
}
